// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginPage_container__328pU","formContainer":"LoginPage_formContainer__5NOXW","imageContainer":"LoginPage_imageContainer__2A7ho","form":"LoginPage_form__18vce"};